import React from 'react'
import useLocalStorage from '../hooks/useLocalStorage';

const AuthContext = React.createContext();

export function AuthProvider({ children }) {

    const [auth, setAuth] = useLocalStorage("auth", null)

    return (
        <AuthContext.Provider value={{ auth, setAuth }}>{children}</AuthContext.Provider>
    )
}

export default AuthContext